import { useEffect, useState } from "react"

const getActiveRoute = () => {
  if (typeof window === "undefined") return "builder"
  return window.location.hash.startsWith("#/terms") ? "terms" : "builder"
}

export const DesktopNav = () => {
  const [active, setActive] = useState(getActiveRoute)

  useEffect(() => {
    if (typeof window === "undefined") return
    const sync = () => setActive(getActiveRoute())
    window.addEventListener("hashchange", sync)
    return () => window.removeEventListener("hashchange", sync)
  }, [])

  return (
    <nav className="hidden md:flex items-center gap-8 text-sm">
      <a
        href="#/"
        className={`hover:text-primary${active === "builder" ? " font-medium underline underline-offset-2" : ""}`}
      >
        Builder
      </a>
      <a
        href="#/terms"
        className={`hover:text-primary${active === "terms" ? " font-medium underline underline-offset-2" : ""}`}
      >
        Terms
      </a>
    </nav>
  )
}
